<style lang="scss" scoped>
.card {
  margin: 0 0.5rem;
}

.buttom-btns {
  width: 250;
  margin: 0 0.5rem 0 0.5rem;
}
.preview {
  position: relative;
  height: 150px;
  width: 250px;
  margin: 0 0.5rem 0 0.5rem;

  .wrapper {
    height: 148px;
    width: 248px;
    padding: 0.5rem;
    background-color: #f9f9f9;
    border: 1px solid gray;
  }

  .media {
    max-height: calc(150px - 2rem);
    max-width: calc(250px - 2rem);
  }

  .badge {
    position: absolute;
    top: -10px;
    right: -15px;
    font-size: 1rem;
    cursor: pointer;
    outline: 0;
    border: 0;
    transition: background-color 0.2s ease-out;

    &:hover {
      background-color: lighten($red, 10);
    }

    &:active {
      background-color: darken($red, 20);
    }
  }
}
</style>

<template>
  <div class="d-flex flex-wrap">
    <div v-for="entry in data" :key="entry.id" class="card">
      <div class="card-body p-0">
        <div class="preview">
          <div class="container">
            <customer-media-edit
              :entry="entry"
              :isFake="isFake"
              :onlyDelete="isAvatar"
            ></customer-media-edit>
          </div>
          <vue-slide-up-down :active="!entry.deleting">
            <div
              class="d-flex align-items-center justify-content-around wrapper"
            >
              <img
                v-if="entry.is_image"
                class="media"
                :src="`${entry.url}?width=100&height=100`"
              />
              <audio
                v-if="entry.is_audio"
                class="media"
                :src="entry.url"
                controls
              ></audio>
            </div>
          </vue-slide-up-down>
          <a
            v-if="entry.is_image"
            :href="entry.url"
            target="_blank"
            class="btn btn-primary float-left"
            ><i class="far fa-image"></i><i class="fas fa-search-plus"></i
          ></a>
          <v-button
            :request="() => destroy(entry)"
            class="btn btn-danger float-right"
          >
            <i class="fas fa-times"></i>
          </v-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="babel">
import CustomerMediaEdit from "@/components/CustomerMediaEdit";

export default {
  components: {
    CustomerMediaEdit
  },
  props: {
    media: {
      type: Array,
      required: true,
    },
    updateUrl:{
      type: String,
    },
    isFake: {
      type: Boolean,
      required: false,
      default: true
    },
    isAvatar: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      data: null,
    }
  },
  created() {
    this.data = this.parseMedia(this.media);
  },
  methods: {
    parseMedia(media) {
      return media.map((entry) => {
        entry.deleting = false;
        entry.settingPrimary = false;
        return entry;
      });
    },
    destroy(media) {
      return new Promise(resolve => {
          this.$http.delete(media.delete_url).then(() => {this.$bus.$emit('media-deleted', media); resolve();})
      });
    },
  },
  watch: {
    media() {
     this.data = this.parseMedia(this.media);
    }
  }
}
</script>
